// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3nx7B","dragIcon":"SortableItem_dragIcon__2IWQy","disabled":"SortableItem_disabled__12wV9"};